import React from 'react';
import './styles.scss';
import { GameIds } from '../../core/constants/gameIds';

function GameWrapper({ gameId, children }) {
  // Todo add class custom-view
  const POG = +gameId === GameIds.PowerOfGods;
  return <div className={`cpt-game-column ${POG ? 'custom-view' : ''}`}>{children}</div>;
}

export default GameWrapper;
